import { render, staticRenderFns } from "./tangram-event-capture.vue?vue&type=template&id=5ebb5a93&scoped=true&"
import script from "./tangram-event-capture.vue?vue&type=script&lang=js&"
export * from "./tangram-event-capture.vue?vue&type=script&lang=js&"
import style0 from "./tangram-event-capture.vue?vue&type=style&index=0&id=5ebb5a93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebb5a93",
  null
  
)

component.options.__file = "tangram-event-capture.vue"
export default component.exports